export const isAuthorizingPrompt = (message) => /authoris|authoriz/i.test(message || '');

// Map a live terminal prompt to a phase: authorising/remove => authorizing, else ready.
export const classifyReaderStatus = (rawMessage) => {
  const message = (rawMessage || '').toLowerCase();
  if (isAuthorizingPrompt(message) || /remove/.test(message)) return 'authorizing';
  return 'ready';
};
